export const UPDATE_USER_INFO = "updateUserInfo";
